import React from "react";
import { Trophy } from "lucide-react";
import { EntregadorStat } from "../types";
import { formatTime } from "../utils/formatTime";

interface Top3EntregadoresProps {
  top3Entregadores: EntregadorStat[];
}

export const Top3Entregadores: React.FC<Top3EntregadoresProps> = ({
  top3Entregadores,
}) => {
  if (top3Entregadores.length === 0) {
    return null;
  }

  return (
    <div className="flex-1 px-4 pb-6 sm:px-6 lg:px-8">
      <div className="mx-auto mb-3 max-w-7xl">
        <div className="rounded-lg border border-white/20 bg-white/10 p-3 backdrop-blur-sm">
          <div className="mb-2 flex items-center justify-center">
            <Trophy className="mr-1 h-4 w-4 text-yellow-400" />
            <h2 className="text-lg font-bold text-yellow-300">
              TOP 3 ENTREGADORES
            </h2>
          </div>
          <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-3">
            {top3Entregadores.map((entregador, index) => (
              <div
                key={entregador.id}
                className={`rounded-lg p-3 text-center ${
                  index === 0
                    ? "border border-green-400/40 bg-gradient-to-br from-green-500/30 to-green-600/20"
                    : index === 1
                      ? "border border-blue-400/40 bg-gradient-to-br from-blue-500/30 to-blue-600/20"
                      : "border border-orange-400/40 bg-gradient-to-br from-orange-500/30 to-orange-600/20"
                }`}
              >
                <div
                  className={`mb-1 text-lg font-bold ${
                    index === 0
                      ? "text-green-300"
                      : index === 1
                        ? "text-blue-300"
                        : "text-orange-300"
                  }`}
                >
                  {index + 1}º {entregador.nome}
                </div>
                <div
                  className={`text-sm ${
                    index === 0
                      ? "text-green-200"
                      : index === 1
                        ? "text-blue-200"
                        : "text-orange-200"
                  }`}
                >
                  Tempo médio: {formatTime(entregador.tempoMedio)}
                </div>
                <div
                  className={`text-xs ${
                    index === 0
                      ? "text-green-100"
                      : index === 1
                        ? "text-blue-100"
                        : "text-orange-100"
                  }`}
                >
                  {entregador.entregas} entregas hoje
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-sm text-white/80">
            A meta é importante, mas a sua vida vale muito mais — dirija sempre
            com responsabilidade.
          </p>
        </div>
      </div>
    </div>
  );
};
